module.exports = __webpack_public_path__ + "static/img/hexingongneng_bj_image@2x.69ca26d9.jpg";